var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCrossIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.89 9.67l-3.149.96-4.11 4.11-.96 3.15-5.89 2.33 2.33-5.89 3.15-.96 4.11-4.11.96-3.15 5.89-2.33-2.33 5.89z",
    fill: "#9A9CAC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.11 9.67l3.15.96 4.11 4.11.96 3.15 5.89 2.33-2.33-5.89-3.15-.96-4.11-4.11-.96-3.15-5.89-2.33 2.33 5.89z",
    fill: "#9A9CAC"
  })));
}

export default SvgCrossIcon;